// extracted by mini-css-extract-plugin
export default {"customCard":"CustomCard_customCard__UL5T5","dropdownMenu":"CustomCard_dropdownMenu__2RLHe","customButton":"CustomCard_customButton__vgRd2"};